import {head} from 'lodash';
import {Collection} from 'backbone';
import TargetModel from '../../models/common/targetModel';

export const sortByCallLetters = (aStation, bStation) => {
    const aCallLetters = aStation.site.callLetters;
    const bCallLetters = bStation.site.callLetters;

    if (aCallLetters < bCallLetters) {
        return -1;
    }
    if (aCallLetters > bCallLetters) {
        return 1;
    }

    return 0;
};

const targetCollectionPrototype = {
    model: TargetModel,
    findByUuid(uuid) {
        return head(this.models.filter(target => target.get('site').get('uuid') === uuid));
    },
    comparator(target) {
        return target.get('site').get('url');
    },
    getTargetSiteAndSection(siteid, sectionid) {
        const findSection = function(prev, next) {
            if (next.uuid === sectionid) {
                return next;
            } else if (prev) {
                return prev;
            } else if (next.subsections && next.subsections.length) {
                return next.subsections.reduce(findSection, null);
            } else {
                return null;
            }
        };

        let target = this.findByUuid(siteid);
        target = target && target.toJSON();

        if (target && target.sections) {
            target.sections = [target.sections.reduce(findSection, null)];
        }

        return new TargetModel(target);
    },
};

export default Collection.extend(targetCollectionPrototype);
